"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { FieldProvider } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-root-provider.tsx
var splitRootProviderProps = createSplitProps();
var FieldRootProvider = forwardRef((props, ref) => {
	const [{ value: field }, localProps] = splitRootProviderProps(props, ["value"]);
	const mergedProps = mergeProps(field.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(FieldProvider, {
		value: field,
		children: /* @__PURE__ */ jsx(ark.div, {
			...mergedProps,
			ref
		})
	});
});
FieldRootProvider.displayName = "FieldRootProvider";
//#endregion
export { FieldRootProvider };
